import { getQueueStatusDisplay } from '@/features/workspace/utils/status-map'

const humanize = (s: string) => s.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase())

/**
 * Queue label + pill for a raw status. Unknown statuses are humanized, never
 * shown raw; the bare `status-badge` (Received) gets the muted pill so every
 * row's status reads as a pill.
 */
export function statusDisplay(status: string, codingMode: string | null) {
  const d = getQueueStatusDisplay(status, codingMode)
  const label = d.label === status ? humanize(status) : d.label
  return { label, badgeClass: d.badgeClass === 'status-badge' ? 'status-badge muted' : d.badgeClass }
}
